import axios from "axios";
import { useRef, useState } from "react";
import Swal from "sweetalert2";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import BannerQuick from "../common/quick/BannerQuick";
import useDeviceType from "../common/useDeviceType";
import ModalPop from "./ModalPop";

const Banner = () => {
  const isMobile = useDeviceType();

  const bannerList = [
    { pc: "/images/banner1.png", mobile: "/images/moBanner1.png" },
    { pc: "/images/banner2.png", mobile: "/images/moBanner2.png" },
    { pc: "/images/banner3.png", mobile: "/images/moBanner3.png" },
    { pc: "/images/banner1.png", mobile: "/images/moBanner1.png" },
    { pc: "/images/banner2.png", mobile: "/images/moBanner2.png" },
    { pc: "/images/banner3.png", mobile: "/images/moBanner3.png" },
  ];

  const [address, setAddress] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!address || !phone) {
      Swal.fire({
        title: "연락처와 주소를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact/quick", {
        name: "배너 간편문의",
        phone: phone,
        address: address,
        type: "",
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <div id="banner" className="relative w-full h-full bg-primary z-20">
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="relative w-full h-full bg-banner">
        <div className="relative w-full h-full px-5 lg:px-0 mx-auto items-center max-w-[1400px] pt-24 lg:pt-32 2xl:pt-36">
          <Swiper
            slidesPerView={1}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              stopOnLastSlide: false,
            }}
            loop={true}
            loopAdditionalSlides={2}
            modules={[Autoplay]}
            className="relative w-full h-full"
          >
            {bannerList.map((v, i) => (
              <SwiperSlide
                key={`banner-${i}`}
                className="relative w-full h-full"
              >
                <div className=" relative w-full h-full pt-10 xl:pt-16">
                  <div className=" relative w-full h-full max-w-screen-lg mx-auto ">
                    <img
                      src={isMobile ? v.mobile : v.pc}
                      alt={`장인배관 누수탐지·고압세척 안내 배너 ${i + 1}`}
                      className="!relative w-full h-auto xl:ml-16"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="hidden lg:block relative w-full h-fit max-w-screen-xl -mt-8 z-10 pb-10 xl:pb-16">
            <div className="relative w-full h-fit grid grid-cols-5 items-start grid-rows-2 -mb-16 gap-5">
              <div className="row-span-2 relative w-full h-full mt-5 cursor-pointer">
                <img
                  onClick={openfunc}
                  src="/images/bannerBtn1.png"
                  alt="장인배관 간편 견적문의 신청 버튼"
                  className="rounded-xl shadow-lg shadow-[rgba(0,0,0,0.4)]"
                />
              </div>
              <div className=" col-span-4 relative w-full h-fit">
                <img
                  src="/images/bannerBtn2.png"
                  alt="장인배관 무료 상담 안내"
                  className=" !relative w-full h-2/3 object-contain rounded-xl shadow-lg shadow-[rgba(0,0,0,0.4)]"
                />
              </div>
              <div className=" col-span-4 relative w-full h-fit grid grid-cols-3 gap-2 -mt-2">
                <input
                  type="text"
                  placeholder="010-0000-0000"
                  value={phone}
                  className="!h-14 !rounded-lg border-2 border-primary shadow-lg shadow-[rgba(0,0,0,0.4)]"
                  id="phone1"
                  onChange={(e) =>
                    setPhone(
                      e.target.value
                        .replace(/[^0-9.]/g, "")
                        .replace(/(\..*)\./g, "$1"),
                    )
                  }
                />
                <input
                  type="text"
                  placeholder="서울(경기 · 인천) 00구 00동 상세주소"
                  className="col-span-2 !h-14 !rounded-lg border-2 border-primary shadow-lg shadow-[rgba(0,0,0,0.4)]"
                  value={address}
                  id="name1"
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
            </div>
            <div className="relative w-full h-fit flex justify-end items-center text-white gap-5">
              <div>
                <p className="text-base">
                  문의 후 10분 이내에 회신이 없다면 전화문의 부탁드립니다.
                </p>
                <div className="flex justify-end items-center gap-1">
                  <input
                    type="checkbox"
                    name="privacy"
                    id="privacy"
                    defaultChecked
                    checked={true}
                    className="!w-3 !h-3"
                  />
                  <label htmlFor="privacy">
                    <p className="text-base">개인정보처리방침 동의</p>
                  </label>
                </div>
              </div>
              <button
                type="button"
                onClick={handlerPostContact}
                disabled={loading}
                className="relative w-fit text-center h-fit pt-2 pb-1 px-6 bg-primary rounded-sm border-2 border-white shadow-lg shadow-[rgba(0,0,0,0.4)]"
              >
                <h4>문자로 전송하기</h4>
              </button>
            </div>
          </div>
        </div>
      </div>
      <BannerQuick />
      <div
        onClick={() => (window.location.href = "tel:010-3409-5404")}
        className="block md:hidden relative w-full h-fit"
      >
        <img
          src="/images/bannerMBtn.png"
          alt="장인배관 전화상담 바로가기 010-3409-5404"
          className="!relative w-full h-auto object-contain"
        />
      </div>
    </div>
  );
};

export default Banner;
